// UPDATED CROP CATEGORY 2026-03-11 17:34
// NEW FIGMA UI (CropCategory) - Active code below
// ============================================================

import React, { useState } from 'react';
import {
    Box, Typography, TextField, InputAdornment, Button, IconButton,
    Tabs, Tab, Grid, useTheme, useMediaQuery,
    Radio, RadioGroup, FormControlLabel
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { colors, fonts } from '../../ColorFont/color';
import NewHeaderNavWithSidebar from '../../components/HeaderNav/NewHeaderNavWithSidebar';
import {
    IconSearch, IconCheck, IconX
} from '@tabler/icons-react';

// ---- Translations ----
const v1Translations = {
    en: {
        whatSelling: 'What are you selling today?',
        sellDesc: 'Select the category that best describes your crop so buyers can find it easily.',
        searchPlaceholder: 'Search crop name (e.g., Wheat, Onion, Mango, Tomato)',
        seasonalFilter: 'SEASONAL FILTER:',
        allSeasons: 'All Seasons',
        language: 'Language',
        selectCategory: 'Select Category',
        addCustomCrop: 'Add Custom\nCrop',
        selectedLabel: 'Selected:',
        cancel: 'Cancel',
        saveContinue: 'Save and Continue',
        addYourCategory: 'Add Category',
        enterCategoryPlaceholder: 'Type category name...',
        addCategoryBtn: 'Add Category',
        addYourCrop: 'Add Crop',
        enterCropPlaceholder: 'Type crop name...',
        addCropBtn: 'Add Crop',
        steps: {
            cropCategory: 'Crop Category',
            varietyGrade: 'Variety & Grade',
            pricing: 'Pricing',
            photos: 'Photos',
            locationDelivery: 'Location & Delivery'
        },
        tabs: {
            fruits: 'Fruits',
            vegetables: 'Vegetables',
            grains: 'Grains & Cereals',
            pulses: 'Pulses',
            oilSeeds: 'Oilseeds',
            spices: 'Spices',
            flowers: 'Flowers',
            medicinal: 'Medicinal & Herbal Plants',
            fodder: 'Fodder Crops',
            plantation: 'Plantation Crops'
        },
        crops: {
            pomegranate: 'Pomegranate', mango: 'Mango', grapes: 'Grapes', banana: 'Banana',
            papaya: 'Papaya', guava: 'Guava', watermelon: 'Watermelon', muskmelon: 'Muskmelon',
            apple: 'Apple', orange: 'Orange', sweetLime: 'Sweet Lime', lemon: 'Lemon',
            pineapple: 'Pineapple',
            onion: 'Onion', potato: 'Potato', tomato: 'Tomato', brinjal: 'Brinjal',
            okra: 'Okra', cabbage: 'Cabbage', cauliflower: 'Cauliflower', carrot: 'Carrot',
            radish: 'Radish', spinach: 'Spinach',
            wheat: 'Wheat', rice: 'Rice', jowar: 'Jowar', bajra: 'Bajra', maize: 'Maize', ragi: 'Ragi',
            chickpeas: 'Chickpeas', greengram: 'Green Gram', blackgram: 'Black Gram', pigeonpea: 'Pigeon Pea',
            groundnut: 'Groundnut', soyabean: 'Soyabean', mustard: 'Mustard', sesame: 'Sesame',
            turmeric: 'Turmeric', redchilli: 'Red Chilli', blackpepper: 'Black Pepper',
            cardamom: 'Cardamom', clove: 'Clove',
            rose: 'Rose', marigold: 'Marigold', jasmine: 'Jasmine', lotus: 'Lotus', hibiscus: 'Hibiscus',
            aloevera: 'Aloe Vera', tulsi: 'Tulsi', ashwagandha: 'Ashwagandha',
            sorghum: 'Sorghum', maizefodder: 'Maize Fodder',
            coconut: 'Coconut', arecanut: 'Areca Nut', coffee: 'Coffee', tea: 'Tea', rubber: 'Rubber'
        },
        other: 'Other',
        categoryLabel: 'Category',
        addCropSubLabel: 'Add Crop',
        addBtn: 'Add',
        cancelBtn: 'Cancel',
        qualityDetailsTitle: 'Quality Details',
        qualityDetailsDesc: "Provide details about your crop's quality to build trust with buyers.",
        cropGradeLabel: 'Crop Grade *',
        gradeOption: 'Grade'
    },
    hi: {
        whatSelling: 'आज आप क्या बेच रहे हैं?',
        sellDesc: 'वह श्रेणी चुनें जो आपकी फसल का सबसे अच्छा वर्णन करती है ताकि खरीदार इसे आसानी से खोज सकें।',
        searchPlaceholder: 'फसल का नाम खोजें (उदा., गेहूं, प्याज, आम, टमाटर)',
        seasonalFilter: 'मौसमी फिल्टर:',
        allSeasons: 'सभी मौसम',
        language: 'भाषा',
        selectCategory: 'श्रेणी चुनें',
        addCustomCrop: 'कस्टम फसल\nजोड़ें',
        selectedLabel: 'चयनित:',
        cancel: 'रद्द करें',
        saveContinue: 'सहेजें और आगे बढ़ें',
        addYourCategory: 'श्रेणी जोड़ें',
        enterCategoryPlaceholder: 'श्रेणी का नाम टाइप करें...',
        addCategoryBtn: 'श्रेणी जोड़ें',
        addYourCrop: 'फसल जोड़ें',
        enterCropPlaceholder: 'फसल का नाम टाइप करें...',
        addCropBtn: 'फसल जोड़ें',
        steps: {
            cropCategory: 'फसल श्रेणी', varietyGrade: 'किस्म और ग्रेड',
            pricing: 'मूल्य निर्धारण', photos: 'तस्वीरें', locationDelivery: 'स्थान और वितरण'
        },
        tabs: {
            fruits: 'फल', vegetables: 'सब्जियां', grains: 'अनाज', pulses: 'दालें',
            oilSeeds: 'तिलहन', spices: 'मसाले', flowers: 'फूल',
            medicinal: 'औषधीय और हर्बल पौधे', fodder: 'चारा फसलें', plantation: 'बागान फसलें'
        },
        crops: {
            pomegranate: 'अनार', mango: 'आम', grapes: 'अंगूर', banana: 'केला',
            papaya: 'पपीता', guava: 'अमरूद', watermelon: 'तरबूज', muskmelon: 'खरबूजा',
            apple: 'सेब', orange: 'संतरा', sweetLime: 'मौसंबी', lemon: 'नींबू',
            pineapple: 'अनानास',
            onion: 'प्याज', potato: 'आलू', tomato: 'टमाटर', brinjal: 'बैंगन',
            okra: 'भिंडी', cabbage: 'पत्ता गोभी', cauliflower: 'फूल गोभी', carrot: 'गाजर',
            radish: 'मूली', spinach: 'पालक',
            wheat: 'गेहूँ', rice: 'चावल', jowar: 'ज्वार', bajra: 'बाजरा', maize: 'मक्का', ragi: 'रागी',
            chickpeas: 'चना', greengram: 'मूंग', blackgram: 'उड़द', pigeonpea: 'अरहर',
            groundnut: 'मूंगफली', soyabean: 'सोयाबीन', mustard: 'सरसों', sesame: 'तिल',
            turmeric: 'हल्दी', redchilli: 'लाल मिर्च', blackpepper: 'काली मिर्च',
            cardamom: 'इलायची', clove: 'लौंग',
            rose: 'गुलाब', marigold: 'गेंदा', jasmine: 'चमेली', lotus: 'कमल', hibiscus: 'गुड़हल',
            aloevera: 'एलोवेरा', tulsi: 'तुलसी', ashwagandha: 'अश्वगंधा',
            sorghum: 'ज्वार (चारा)', maizefodder: 'मक्का (चारा)',
            coconut: 'नारियल', arecanut: 'सुपारी', coffee: 'कॉफी', tea: 'चाय', rubber: 'रबर'
        },
        other: 'अन्य',
        categoryLabel: 'श्रेणी',
        addCropSubLabel: 'फसल जोड़ें',
        addBtn: 'जोड़ें',
        cancelBtn: 'रद्द करें',
        qualityDetailsTitle: 'गुणवत्ता विवरण',
        qualityDetailsDesc: 'खरीदारों के साथ विश्वास बनाने के लिए अपनी फसल की गुणवत्ता के बारे में विवरण प्रदान करें।',
        cropGradeLabel: 'फसल का ग्रेड *',
        gradeOption: 'ग्रेड'
    },
    mr: {
        whatSelling: 'आज तुम्ही काय विकत आहात?',
        sellDesc: 'तुमच्या पिकाचे उत्तम वर्णन करणारी श्रेणी निवडा जेणेकरून खरेदीदारांना ते सहज सापडेल.',
        searchPlaceholder: 'पिकाचे नाव शोधा (उदा., गहू, कांदा, आंबा, टोमॅटो)',
        seasonalFilter: 'हंगामी फिल्टर:',
        allSeasons: 'सर्व हंगाम',
        language: 'भाषा',
        selectCategory: 'श्रेणी निवडा',
        addCustomCrop: 'सानुकूल पीक\nजोडा',
        selectedLabel: 'निवडलेले:',
        cancel: 'रद्द करा',
        saveContinue: 'जतन करा आणि पुढे जा',
        addYourCategory: 'श्रेणी जोडा',
        enterCategoryPlaceholder: 'श्रेणीचे नाव टाइप करा...',
        addCategoryBtn: 'श्रेणी जोडा',
        addYourCrop: 'पीक जोडा',
        enterCropPlaceholder: 'पिकाचे नाव टाइप करा...',
        addCropBtn: 'पीक जोडा',
        steps: {
            cropCategory: 'पीक श्रेणी', varietyGrade: 'वाण आणि दर्जा',
            pricing: 'किंमत', photos: 'फोटो', locationDelivery: 'स्थान आणि वितरण'
        },
        tabs: {
            fruits: 'फळे', vegetables: 'भाज्या', grains: 'धान्य', pulses: 'डाळी',
            oilSeeds: 'तेलबिया', spices: 'मसाले', flowers: 'फुले',
            medicinal: 'औषधीय आणि हर्बल वनस्पती', fodder: 'चारा पिके', plantation: 'मशागत पिके'
        },
        crops: {
            pomegranate: 'डाळिंब', mango: 'आंबा', grapes: 'द्राक्षे', banana: 'केळी',
            papaya: 'पपई', guava: 'पेरू', watermelon: 'कलिंगड', muskmelon: 'खरबूज',
            apple: 'सफरचंद', orange: 'संत्रे', sweetLime: 'मोसंबी', lemon: 'लिंबू',
            pineapple: 'अननस',
            onion: 'कांदा', potato: 'बटाटा', tomato: 'टोमॅटो', brinjal: 'वांगी',
            okra: 'भेंडी', cabbage: 'कोबी', cauliflower: 'फ्लॉवर', carrot: 'गाजर',
            radish: 'मुळा', spinach: 'पालक',
            wheat: 'गहू', rice: 'तांदूळ', jowar: 'ज्वारी', bajra: 'बाजरी', maize: 'मका', ragi: 'नाचणी',
            chickpeas: 'हरभरा', greengram: 'मूग', blackgram: 'उडीद', pigeonpea: 'तूर',
            groundnut: 'भुईमूग', soyabean: 'सोयाबीन', mustard: 'मोहरी', sesame: 'तीळ',
            turmeric: 'हळद', redchilli: 'लाल मिरची', blackpepper: 'काळी मिरी',
            cardamom: 'वेलची', clove: 'लवंग',
            rose: 'गुलाब', marigold: 'झेंडू', jasmine: 'चमेली', lotus: 'कमल', hibiscus: 'जास्वंद',
            aloevera: 'कोरफड', tulsi: 'तुळस', ashwagandha: 'अश्वगंधा',
            sorghum: 'ज्वारी (चारा)', maizefodder: 'मका (चारा)',
            coconut: 'नारळ', arecanut: 'सुपारी', coffee: 'कॉफी', tea: 'चहा', rubber: 'रबर'
        },
        other: 'इतर',
        categoryLabel: 'श्रेणी',
        addCropSubLabel: 'पीक जोडा',
        addBtn: 'जोडा',
        cancelBtn: 'रद्द करा',
        qualityDetailsTitle: 'गुणवत्ता तपशील',
        qualityDetailsDesc: 'खरेदीदारांचा विश्वास जिंकण्यासाठी तुमच्या पिकाच्या गुणवत्तेबद्दल तपशील द्या.',
        cropGradeLabel: 'पिकाचा दर्जा *',
        gradeOption: 'दर्जा'
    }
};

// ---- Main Component ----
const CropCategory = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();
    const langCode = i18n.language || 'en';
    const currentLang = langCode.startsWith('hi') ? 'hi' : (langCode.startsWith('mr') || langCode.startsWith('mar')) ? 'mr' : 'en';
    const tLocal = v1Translations[currentLang];

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const existingData = location.state?.cropData || {};

    const [activeTab, setActiveTab] = useState(0);
    const [selectedCropId, setSelectedCropId] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [grade, setGrade] = useState(existingData.grade || '');
    const [variety, setVariety] = useState(existingData.variety || '');
    const [customCrops, setCustomCrops] = useState([]);
    const [customInput, setCustomInput] = useState('');
    const [categoryInput, setCategoryInput] = useState('');
    const [isAddingCustom, setIsAddingCustom] = useState(false);
    const [errors, setErrors] = useState({});

    // Refs for scrolling to errors
    const cropRef = React.useRef(null);
    const gradeRef = React.useRef(null);

    // Localization for validation messages
    const validationMsgs = {
        en: { 
            cropReq: 'Please select a crop', 
            gradeReq: 'Please select a grade (A, B, or C)',
            varietyLabel: 'Variety (Optional)',
            varietyPlaceholder: 'e.g. Bhagwa, Hybrid'
        },
        hi: { 
            cropReq: 'कृपया एक फसल चुनें', 
            gradeReq: 'कृपया एक ग्रेड (A, B, या C) चुनें',
            varietyLabel: 'किस्म (वैकल्पिक)',
            varietyPlaceholder: 'जैसे: भगवा, हाइब्रिड'
        },
        mr: { 
            cropReq: 'कृपया एक पीक निवडा', 
            gradeReq: 'कृपया ग्रेड (A, B, किंवा C) निवडा',
            varietyLabel: 'वाण (पर्यायी)',
            varietyPlaceholder: 'उदा. भगवा, संकरित'
        }
    };
    const tVal = validationMsgs[currentLang] || validationMsgs.en;

    const scrollToFirstError = (newErrors) => {
        if (newErrors.crop) {
            cropRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (newErrors.grade) {
            gradeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    const categoryEnum = [
        'Fruits', 'Vegetables', 'Grains & Cereals', 'Pulses',
        'Oilseeds', 'Spices', 'Flowers', 'Medicinal & Herbal Plants',
        'Fodder Crops', 'Plantation Crops', 'Other'
    ];

    const tabLabels = [
        tLocal.tabs?.fruits, tLocal.tabs?.vegetables, tLocal.tabs?.grains, tLocal.tabs?.pulses,
        tLocal.tabs?.oilSeeds, tLocal.tabs?.spices, tLocal.tabs?.flowers,
        tLocal.tabs?.medicinal, tLocal.tabs?.fodder, tLocal.tabs?.plantation,
        tLocal.other || 'Other'
    ];

    React.useEffect(() => {
        if (existingData.category) {
            const catArr = existingData.category;
            const cat = Array.isArray(catArr) ? (catArr[0] || '') : (catArr || '');
            
            // Match against English categoryEnum first, then tabLabels (legacy fallback)
            let idx = categoryEnum.indexOf(cat);
            if (idx === -1) idx = tabLabels.indexOf(cat);

            if (idx !== -1 && idx < CUSTOM_TAB_INDEX) {
                setActiveTab(idx);
                setSelectedCropId(existingData.subCategory || '');
            } else if (cat !== '') {
                // If not in standard tabs, it's custom
                setActiveTab(CUSTOM_TAB_INDEX);
                setIsAddingCustom(false); // Don't show input box, just show selected
                setCategoryInput(cat);
                const subCat = existingData.subCategory || '';
                const id = 'custom_' + subCat.toLowerCase().replace(/\s+/g, '_');
                setCustomCrops([{ 
                    id, 
                    label: subCat, 
                    category: CUSTOM_TAB_INDEX, 
                    categoryName: cat 
                }]);
                setSelectedCropId(id);
            }
            if (existingData.grade) setGrade(existingData.grade);
            if (existingData.variety) setVariety(existingData.variety);
        }
    }, [existingData.category]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        setIsAddingCustom(false);
        setCategoryInput('');
        setCustomInput('');
    };

    const toggleCrop = (cropId) => {
        if (selectedCropId === cropId) {
            setSelectedCropId('');
        } else {
            setSelectedCropId(cropId);
            setErrors(prev => ({ ...prev, crop: "" }));
            if (!cropId.toString().startsWith('custom_')) {
                setCustomCrops([]);
                setIsAddingCustom(false);
            }
        }
    };

    const CUSTOM_TAB_INDEX = 10;

    const handleAddCustomCrop = () => {
        const catTrimmed = String(categoryInput || '').trim();
        const cropTrimmed = String(customInput || '').trim();
        if (!catTrimmed || !cropTrimmed) return;
        
        const id = 'custom_' + cropTrimmed.toLowerCase().replace(/\s+/g, '_');
        setCustomCrops([{ 
            id, 
            label: cropTrimmed, 
            category: activeTab, 
            categoryName: catTrimmed 
        }]);

        setCustomInput('');
        setCategoryInput('');
        setIsAddingCustom(false);
        setSelectedCropId(id);
    };

    const stepperData = [
        { label: tLocal.steps?.cropCategory || 'Crop Category', active: true, done: false, step: 1 },
        { label: tLocal.steps?.varietyGrade || 'Variety & Grade', active: false, done: false, step: 2 },
        { label: tLocal.steps?.pricing || 'Pricing', active: false, done: false, step: 3 },
        { label: tLocal.steps?.photos || 'Photos', active: false, done: false, step: 4 },
        { label: tLocal.steps?.locationDelivery || 'Location & Delivery', active: false, done: false, step: 5 },
    ];

    const ALL_CROPS = [
        { id: 'Pomegranate', label: tLocal.crops?.pomegranate || 'Pomegranate', category: 0 },
        { id: 'Mango', label: tLocal.crops?.mango || 'Mango', category: 0 },
        { id: 'Grapes', label: tLocal.crops?.grapes || 'Grapes', category: 0 },
        { id: 'Banana', label: tLocal.crops?.banana || 'Banana', category: 0 },
        { id: 'Papaya', label: tLocal.crops?.papaya || 'Papaya', category: 0 },
        { id: 'Guava', label: tLocal.crops?.guava || 'Guava', category: 0 },
        { id: 'Watermelon', label: tLocal.crops?.watermelon || 'Watermelon', category: 0 },
        { id: 'Muskmelon', label: tLocal.crops?.muskmelon || 'Muskmelon', category: 0 },
        { id: 'Apple', label: tLocal.crops?.apple || 'Apple', category: 0 },
        { id: 'Orange', label: tLocal.crops?.orange || 'Orange', category: 0 },
        { id: 'Sweet Lime', label: tLocal.crops?.sweetLime || 'Sweet Lime', category: 0 },
        { id: 'Lemon', label: tLocal.crops?.lemon || 'Lemon', category: 0 },
        { id: 'Pineapple', label: tLocal.crops?.pineapple || 'Pineapple', category: 0 },
        { id: 'Onion', label: tLocal.crops?.onion || 'Onion', category: 1 },
        { id: 'Potato', label: tLocal.crops?.potato || 'Potato', category: 1 },
        { id: 'Tomato', label: tLocal.crops?.tomato || 'Tomato', category: 1 },
        { id: 'Brinjal', label: tLocal.crops?.brinjal || 'Brinjal', category: 1 },
        { id: 'Okra', label: tLocal.crops?.okra || 'Okra', category: 1 },
        { id: 'Cabbage', label: tLocal.crops?.cabbage || 'Cabbage', category: 1 },
        { id: 'Cauliflower', label: tLocal.crops?.cauliflower || 'Cauliflower', category: 1 },
        { id: 'Carrot', label: tLocal.crops?.carrot || 'Carrot', category: 1 },
        { id: 'Radish', label: tLocal.crops?.radish || 'Radish', category: 1 },
        { id: 'Spinach', label: tLocal.crops?.spinach || 'Spinach', category: 1 },
        { id: 'Wheat', label: tLocal.crops?.wheat || 'Wheat', category: 2 },
        { id: 'Rice', label: tLocal.crops?.rice || 'Rice', category: 2 },
        { id: 'Jowar', label: tLocal.crops?.jowar || 'Jowar', category: 2 },
        { id: 'Bajra', label: tLocal.crops?.bajra || 'Bajra', category: 2 },
        { id: 'Maize', label: tLocal.crops?.maize || 'Maize', category: 2 },
        { id: 'Ragi', label: tLocal.crops?.ragi || 'Ragi', category: 2 },
        { id: 'Chickpeas', label: tLocal.crops?.chickpeas || 'Chickpeas', category: 3 },
        { id: 'Green Gram', label: tLocal.crops?.greengram || 'Green Gram', category: 3 },
        { id: 'Black Gram', label: tLocal.crops?.blackgram || 'Black Gram', category: 3 },
        { id: 'Pigeon Pea', label: tLocal.crops?.pigeonpea || 'Pigeon Pea', category: 3 },
        { id: 'Groundnut', label: tLocal.crops?.groundnut || 'Groundnut', category: 4 },
        { id: 'Soyabean', label: tLocal.crops?.soyabean || 'Soyabean', category: 4 },
        { id: 'Mustard', label: tLocal.crops?.mustard || 'Mustard', category: 4 },
        { id: 'Sesame', label: tLocal.crops?.sesame || 'Sesame', category: 4 },
        { id: 'Turmeric', label: tLocal.crops?.turmeric || 'Turmeric', category: 5 },
        { id: 'Red Chilli', label: tLocal.crops?.redchilli || 'Red Chilli', category: 5 },
        { id: 'Black Pepper', label: tLocal.crops?.blackpepper || 'Black Pepper', category: 5 },
        { id: 'Cardamom', label: tLocal.crops?.cardamom || 'Cardamom', category: 5 },
        { id: 'Clove', label: tLocal.crops?.clove || 'Clove', category: 5 },
        { id: 'Rose', label: tLocal.crops?.rose || 'Rose', category: 6 },
        { id: 'Marigold', label: tLocal.crops?.marigold || 'Marigold', category: 6 },
        { id: 'Jasmine', label: tLocal.crops?.jasmine || 'Jasmine', category: 6 },
        { id: 'Lotus', label: tLocal.crops?.lotus || 'Lotus', category: 6 },
        { id: 'Hibiscus', label: tLocal.crops?.hibiscus || 'Hibiscus', category: 6 },
        { id: 'Aloe Vera', label: tLocal.crops?.aloevera || 'Aloe Vera', category: 7 },
        { id: 'Tulsi', label: tLocal.crops?.tulsi || 'Tulsi', category: 7 },
        { id: 'Ashwagandha', label: tLocal.crops?.ashwagandha || 'Ashwagandha', category: 7 },
        { id: 'Sorghum', label: tLocal.crops?.sorghum || 'Sorghum', category: 8 },
        { id: 'Maize Fodder', label: tLocal.crops?.maizefodder || 'Maize Fodder', category: 8 },
        { id: 'Coconut', label: tLocal.crops?.coconut || 'Coconut', category: 9 },
        { id: 'Areca Nut', label: tLocal.crops?.arecanut || 'Areca Nut', category: 9 },
        { id: 'Coffee', label: tLocal.crops?.coffee || 'Coffee', category: 9 },
        { id: 'Tea', label: tLocal.crops?.tea || 'Tea', category: 9 },
        { id: 'Rubber', label: tLocal.crops?.rubber || 'Rubber', category: 9 }
    ];
    const ALL_CROPSLIST = [...ALL_CROPS, ...customCrops];

    const displayedCrops = ALL_CROPSLIST.filter(crop => {
        if (searchQuery.trim() !== '') {
            return (
                crop.label?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                crop.id.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }
        if (activeTab === CUSTOM_TAB_INDEX) return crop.category === CUSTOM_TAB_INDEX;
        return crop.category === activeTab;
    });

    // PRIMARY is now used directly from colors object to ensure reactivity

    return (
        <Box sx={{
            width: '100%',
            minHeight: '100vh',
            backgroundColor: colors.white_bg || '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            pb: '160px'
        }}>
            <Box sx={{ width: '100%', maxWidth: '850px', p: { xs: 0, md: 0 }, pt: { xs: 2, md: 4 }, display: 'flex', flexDirection: 'column' }}>

                {/* ===== STEPPER ===== */}
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', mb: { xs: 3, md: 5 }, position: 'relative' }}>
                    <Box sx={{
                        position: 'absolute', top: '12px', left: '5%', width: '90%',
                        height: '2px', backgroundColor: colors.add_crop_stepper_inactive || '#DFE3E8', zIndex: 0
                    }} />
                    {stepperData.map((item) => (
                        <Box key={item.step} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, position: 'relative', zIndex: 1 }}>
                            <Box sx={{
                                width: '28px', height: '28px', borderRadius: '50%',
                                backgroundColor: item.done ? colors.primary : (item.active ? colors.primary : (colors.add_crop_stepper_inactive || '#DFE3E8')),
                                display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1
                            }}>
                                {item.done ? (
                                    <IconCheck size={16} stroke={3} color="#FFFFFF" />
                                ) : (
                                    <Typography sx={{ fontFamily: fonts.poppins, fontSize: '12px', fontWeight: 700, color: item.active ? '#FFFFFF' : '#637381' }}>
                                        {item.step}
                                    </Typography>
                                )}
                            </Box>
                            <Typography sx={{
                                fontFamily: fonts.publicSans || fonts.poppins, fontWeight: item.active ? 700 : 600,
                                fontSize: '11px', color: item.active ? '#1C252E' : '#919EAB',
                                textAlign: 'center', whiteSpace: 'nowrap'
                            }}>
                                {item.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                {/* ===== TITLE ===== */}
                <Box sx={{ mb: 4 }}>
                    <Typography sx={{ fontFamily: fonts.poppins, fontWeight: 800, fontSize: { xs: '24px', md: '28px' }, color: '#1C252E', mb: 1 }}>
                        {location.state?.isEdit ? (currentLang === 'hi' ? 'अपनी लिस्टिंग संपादित करें' : currentLang === 'mr' ? 'तुमची लिस्टिंग संपादित करा' : 'Edit your listing') : tLocal.whatSelling}
                    </Typography>
                    <Typography sx={{ fontFamily: fonts.publicSans || fonts.poppins, fontWeight: 500, fontSize: '15px', color: '#637381' }}>
                        {tLocal.sellDesc}
                    </Typography>
                </Box>

                {/* ===== SEARCH ===== */}
                <Box sx={{ mb: 4 }}>
                    <TextField
                        fullWidth
                        placeholder={tLocal.searchPlaceholder}
                        variant="outlined"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconSearch size={20} color="#919EAB" />
                                </InputAdornment>
                            ),
                            endAdornment: searchQuery ? (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setSearchQuery('')} edge="end" size="small">
                                        <IconX size={20} color="#919EAB" />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                            sx: {
                                backgroundColor: '#FFFFFF', borderRadius: '12px',
                                fontFamily: fonts.publicSans || fonts.poppins, fontSize: '15px', height: '52px',
                                '& fieldset': { borderColor: '#E0E5EB' },
                                '&:hover fieldset': { borderColor: '#919EAB' },
                                '&.Mui-focused fieldset': { borderColor: colors.primary }
                            }
                        }}
                    />
                </Box>

                {/* ===== TABS (hidden during search) ===== */}
                {!searchQuery && (
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
                        <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto"
                            TabIndicatorProps={{ style: { backgroundColor: colors.primary, height: '3px', borderRadius: '3px 3px 0 0' } }}
                            sx={{
                                '& .MuiTab-root': { minWidth: 'auto', px: 2, backgroundColor: 'transparent !important' },
                                '& .MuiTab-root.Mui-selected': { backgroundColor: 'transparent !important', color: colors.primary },
                                '& .MuiTab-root:hover': { backgroundColor: 'transparent !important' },
                                '& .MuiTouchRipple-root': { display: 'none' }
                            }}>
                            {tabLabels.map((tabLabel, idx) => (
                                <Tab disableRipple key={idx} label={tabLabel} sx={{
                                    textTransform: 'none', fontFamily: fonts.publicSans || fonts.poppins,
                                    fontWeight: activeTab === idx ? 700 : 600, fontSize: '14px',
                                    color: activeTab === idx ? colors.primary : '#637381',
                                }} />
                            ))}
                        </Tabs>
                    </Box>
                )}

                {/* ===== CROP GRID ===== */}
                <Box ref={cropRef} sx={{ mb: 4 }}>
                    {!searchQuery && (
                        <Typography sx={{ 
                            fontFamily: fonts.publicSans || fonts.poppins, 
                            fontWeight: 700, fontSize: '11px', letterSpacing: '1px', 
                            color: errors.crop ? '#FF4842' : '#919EAB', 
                            mb: 3, textTransform: 'none' 
                        }}>
                            {tLocal.selectCategory} : {(() => {
                                const selectedCrop = ALL_CROPSLIST.find(c => c.id === selectedCropId);
                                if (selectedCrop && selectedCrop.categoryName) return selectedCrop.categoryName;
                                if (isAddingCustom && String(categoryInput || '').trim()) return String(categoryInput || '').trim();
                                return tabLabels[activeTab];
                            })()}
                        </Typography>
                    )}

                    <Grid container spacing={2}>
                        {displayedCrops.map(crop => {
                            const isSelected = selectedCropId === crop.id;
                            const hasError = errors.crop && !isSelected;
                            return (
                                <Grid item xs={6} sm={4} md={3} key={crop.id}>
                                    <Box
                                        onClick={() => toggleCrop(crop.id)}
                                        onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.borderColor = colors.primary; }}
                                        onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.borderColor = hasError ? '#FF4842' : '#E0E5EB'; }}
                                        style={{
                                            width: '100%', minHeight: '60px', borderRadius: '12px',
                                            border: '1px solid ' + (isSelected ? colors.primary : (hasError ? '#FF4842' : '#E0E5EB')),
                                            backgroundColor: isSelected ? colors.primary_rgba_8 : '#FFFFFF',
                                            display: 'flex', alignItems: 'center',
                                            justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s', padding: '12px'
                                        }}>
                                        <Typography sx={{
                                            fontFamily: fonts.poppins,
                                            fontWeight: isSelected ? 800 : 700,
                                            fontSize: { xs: '13px', md: '14px' },
                                            color: isSelected ? colors.primary : '#1C252E',
                                            textAlign: 'center'
                                        }}>
                                            {crop.label}
                                        </Typography>
                                    </Box>
                                </Grid>
                            );
                        })}

                        {/* Other Card Item trigger */}
                        {isAddingCustom ? (
                            <Grid item xs={12} sm={8} md={6}>
                                <Box sx={{
                                    p: 2, borderRadius: '12px', border: '2px solid ' + colors.primary,
                                    backgroundColor: '#FFFFFF', display: 'flex', flexDirection: 'column', gap: 1.5
                                }}>
                                    <Box>
                                        <Typography sx={{ fontFamily: fonts.publicSans || fonts.poppins, fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', color: '#919EAB', mb: 0.5 }}>
                                            {tLocal.categoryLabel || 'Category'}
                                        </Typography>
                                        <TextField
                                            fullWidth size="small"
                                            autoFocus={activeTab === CUSTOM_TAB_INDEX}
                                            placeholder={activeTab === CUSTOM_TAB_INDEX ? tLocal.enterCategoryPlaceholder : ""}
                                            value={categoryInput}
                                            onChange={(e) => {
                                                if (activeTab === CUSTOM_TAB_INDEX) setCategoryInput(e.target.value);
                                            }}
                                            disabled={activeTab !== CUSTOM_TAB_INDEX}
                                            sx={{ 
                                                '& .MuiOutlinedInput-root': { 
                                                    height: '36px', borderRadius: '8px', fontSize: '14px',
                                                    backgroundColor: activeTab === CUSTOM_TAB_INDEX ? '#FFFFFF' : '#F4F6F4',
                                                    '& fieldset': { 
                                                        borderColor: activeTab === CUSTOM_TAB_INDEX ? '#E0E5EB' : 'transparent',
                                                        borderStyle: activeTab === CUSTOM_TAB_INDEX ? 'solid' : 'none'
                                                    }
                                                },
                                                '& .Mui-disabled': { color: '#1C252E', WebkitTextFillColor: '#1C252E', fontWeight: 600 }
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <Typography sx={{ fontFamily: fonts.publicSans || fonts.poppins, fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', color: '#919EAB', mb: 0.5 }}>
                                            {tLocal.addCropSubLabel || 'Add Crop'}
                                        </Typography>
                                        <TextField
                                            fullWidth size="small" 
                                            autoFocus={activeTab !== CUSTOM_TAB_INDEX}
                                            placeholder={tLocal.enterCropPlaceholder}
                                            value={customInput}
                                            onChange={(e) => setCustomInput(e.target.value)}
                                            onKeyDown={(e) => { if (e.key === 'Enter') handleAddCustomCrop(); }}
                                            sx={{ '& .MuiOutlinedInput-root': { height: '36px', borderRadius: '8px', fontSize: '14px' } }}
                                        />
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                                        <Button variant="contained" fullWidth size="small" onClick={handleAddCustomCrop} sx={{ backgroundColor: colors.primary, borderRadius: '8px', textTransform: 'none', fontWeight: 700 }}>
                                            {tLocal.addBtn || 'Add'}
                                        </Button>
                                        <Button variant="outlined" size="small" onClick={() => setIsAddingCustom(false)} sx={{ borderColor: '#E0E5EB', color: '#637381', borderRadius: '8px', textTransform: 'none' }}>
                                            {tLocal.cancelBtn || 'Cancel'}
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        ) : (
                            <Grid item xs={6} sm={4} md={3}>
                                <Box
                                    onClick={() => {
                                        setIsAddingCustom(true);
                                        if (activeTab === CUSTOM_TAB_INDEX) setCategoryInput('');
                                        else setCategoryInput(tabLabels[activeTab]);
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = colors.primary_rgba_8; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#F4F6F4'; }}
                                    style={{
                                        width: '100%', minHeight: '60px', borderRadius: '12px',
                                        border: '2px dashed ' + colors.primary, backgroundColor: '#F4F6F4',
                                        display: 'flex', alignItems: 'center',
                                        justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s', padding: '12px'
                                    }}>
                                    <Typography sx={{ fontFamily: fonts.poppins, fontWeight: 800, fontSize: '13px', color: colors.primary, textAlign: 'center' }}>
                                        {tLocal.other || 'Other'}
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                    {errors.crop && (
                        <Typography sx={{ color: '#FF4842', fontSize: '13px', fontWeight: 600, mt: 2, fontFamily: fonts.publicSans || fonts.poppins }}>
                            {tVal.cropReq}
                        </Typography>
                    )}
                </Box>

                {/* ===== GRADE SECTION ===== */}
                <Box ref={gradeRef} sx={{ 
                    mt: 4, p: { xs: 3, md: 4 }, borderRadius: '16px', 
                    border: '1px solid ' + (errors.grade ? '#FF4842' : '#E0E5EB'), 
                    backgroundColor: '#FFFFFF', boxShadow: '0 4px 20px rgba(0,0,0,0.03)' 
                }}>
                    <Typography sx={{ fontFamily: fonts.poppins, fontWeight: 800, fontSize: { xs: '18px', md: '20px' }, color: '#1C252E', mb: 1, textAlign: 'center' }}>
                        {tLocal.qualityDetailsTitle || 'Quality Details'}
                    </Typography>
                    <Typography sx={{ fontFamily: fonts.publicSans || fonts.poppins, fontWeight: 500, fontSize: '14px', color: '#637381', mb: 4, textAlign: 'center' }}>
                        {tLocal.qualityDetailsDesc || "Provide details about your crop's quality to build trust with buyers."}
                    </Typography>
                    
                    <Grid container spacing={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Grid item xs={12} md={8}>
                            {/* Variety Input */}
                            <Box sx={{ mb: 4 }}>
                                <Typography sx={{ 
                                    fontFamily: fonts.publicSans || fonts.poppins, 
                                    fontWeight: 700, fontSize: '13px', 
                                    color: colors.primary, 
                                    mb: 1.5, textAlign: 'center',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px'
                                }}>
                                    {tVal.varietyLabel}
                                </Typography>
                                <TextField
                                    fullWidth
                                    placeholder={tVal.varietyPlaceholder}
                                    value={variety}
                                    onChange={(e) => setVariety(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                            fontFamily: fonts.publicSans,
                                            fontSize: '15px',
                                            '& fieldset': { borderColor: '#E0E5EB' },
                                            '&:hover fieldset': { borderColor: '#919EAB' },
                                            '&.Mui-focused fieldset': { borderColor: colors.primary }
                                        }
                                    }}
                                />
                            </Box>

                            <Typography sx={{ 
                                fontFamily: fonts.publicSans || fonts.poppins, 
                                fontWeight: 700, fontSize: '13px', 
                                color: errors.grade ? '#FF4842' : colors.primary, 
                                mb: 1, textAlign: 'center',
                                textTransform: 'uppercase',
                                letterSpacing: '1px'
                            }}>
                                {tLocal.cropGradeLabel || 'Crop Grade *'}
                            </Typography>
                            <RadioGroup 
                                row value={grade} 
                                onChange={(e) => {
                                    setGrade(e.target.value);
                                    setErrors(prev => ({ ...prev, grade: "" }));
                                }} 
                                sx={{ justifyContent: 'center', mt: 0.5 }}
                            >
                                {['A', 'B', 'C'].map(g => (
                                    <FormControlLabel key={g} value={g}
                                        control={<Radio sx={{ color: '#DFE3E8', '&.Mui-checked': { color: colors.primary } }} />}
                                        label={<Typography sx={{ fontFamily: fonts.publicSans || fonts.poppins, fontSize: '15px', fontWeight: grade === g ? 700 : 500 }}>{tLocal.gradeOption || 'Grade'} {g}</Typography>}
                                    />
                                ))}
                            </RadioGroup>
                            {errors.grade && (
                                <Typography sx={{ color: '#FF4842', fontSize: '12px', fontWeight: 600, mt: 0.5, textAlign: 'center', fontFamily: fonts.publicSans || fonts.poppins }}>
                                    {tVal.gradeReq}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            {/* ===== BOTTOM BAR: SELECTED + ACTIONS ===== */}
            <Box sx={{
                width: '100%', maxWidth: '850px', px: 0, mt: 6, mb: 4,
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                borderTop: '1px solid #DFE3E8', pt: 4, gap: 3
            }}>
                {/* Selected Tags */}
                {selectedCropId && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                        <Typography sx={{ fontFamily: fonts.publicSans || fonts.poppins, fontWeight: 700, fontSize: '11px', letterSpacing: '1px', color: '#919EAB' }}>
                            {tLocal.selectedLabel}
                        </Typography>
                        <Box sx={{
                            display: 'flex', alignItems: 'center', gap: '4px', height: '36px',
                            pl: 2, pr: 1, backgroundColor: colors.primary_rgba_8,
                            border: '1px solid ' + colors.primary, borderRadius: '18px'
                        }}>
                            <Typography sx={{ fontFamily: fonts.publicSans || fonts.poppins, fontWeight: 700, fontSize: '14px', color: '#10451D' }}>
                                {(() => {
                                    const found = ALL_CROPSLIST.find(c => c.id === selectedCropId);
                                    if (!found) return selectedCropId;
                                    const catName = found.categoryName || tabLabels[found.category] || '';
                                    return catName ? `${catName} > ${found.label}` : found.label;
                                })()}
                            </Typography>
                            <IconButton size="small" onClick={() => setSelectedCropId('')} sx={{ p: 0.5, color: '#10451D' }}>
                                <IconX size={16} stroke={3} />
                            </IconButton>
                        </Box>
                    </Box>
                )}

                <Box sx={{ 
                    display: 'flex', gap: { xs: 2, md: 3 }, width: { xs: '100%', sm: 'auto' },
                    flexDirection: { xs: 'column-reverse', sm: 'row' }, justifyContent: 'center'
                }}>
                    <Button variant="outlined" 
                        onClick={() => navigate('/home')}
                        sx={{
                        height: '52px', borderRadius: '50px', minWidth: { sm: '180px' },
                        px: { xs: 4, md: 6 }, color: '#1C252E', border: '1px solid #DFE3E8',
                        textTransform: 'none', fontFamily: fonts.publicSans || fonts.poppins,
                        fontWeight: 700, fontSize: '15px',
                        '&:hover': { backgroundColor: '#F4F6F8', borderColor: '#919EAB' }
                    }}>
                        {tLocal.cancel}
                    </Button>
                    <Button variant="contained"
                        onClick={() => {
                            const found = ALL_CROPSLIST.find(c => c.id === selectedCropId);
                            const newErrors = {};
                            if (!found) newErrors.crop = true;
                            if (!grade) newErrors.grade = true;

                            if (Object.keys(newErrors).length > 0) {
                                setErrors(newErrors);
                                scrollToFirstError(newErrors);
                                return;
                            }

                            const catName = (activeTab === CUSTOM_TAB_INDEX) ? categoryInput : categoryEnum[activeTab];
                            const cropData = {
                                ...(location.state?.cropData || {}),
                                category: catName,
                                subCategory: found.id,
                                grade: grade || 'A', 
                                variety: variety || '',
                            };
                            navigate('/pricing', { 
                                state: { 
                                    cropData,
                                    isEdit: location.state?.isEdit,
                                    cropId: location.state?.cropId
                                } 
                            });
                        }}
                        disabled={!selectedCropId}
                        sx={{
                            height: '52px', borderRadius: '50px', minWidth: { sm: '200px' },
                            px: { xs: 4, md: 6 }, backgroundColor: colors.primary, color: '#FFFFFF', textTransform: 'none',
                            fontFamily: fonts.publicSans || fonts.poppins, fontWeight: 700, fontSize: '15px',
                            boxShadow: 'none', '&:hover': { backgroundColor: colors.primary_dark, boxShadow: 'none' },
                            '&.Mui-disabled': { backgroundColor: '#F4F6F8', color: '#919EAB' }
                        }}>
                        {tLocal.saveContinue}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default CropCategory;
